__turbopack_context__.v({
  "boostedText": "e0GCEW_boostedText",
  "container": "e0GCEW_container",
  "pillsContainer": "e0GCEW_pillsContainer",
});
